import { AfterViewInit, Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { IMCMapView } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-map-info-container',
    styleUrls: ['../../sharedStyles/base.scss', './map-info-container.component.scss'],
    templateUrl: './map-info-container.component.html'
})
export class MapInfoContainerComponent extends BaseComponent implements AfterViewInit {
    @Input()
    mapViewRef: IMCMapView;

    @Input()
    showDescription = true;

    @Input()
    @InputConverter(BooleanConverter)
    editable = false;

    collapseDescription = true;
    showOptionMenu = true;
    editTitle = false;
    mapName: string;

    @Input()
    @InputConverter(BooleanConverter)
    get isCompact() {
        return this._isCompact;
    }
    set isCompact(value) {
        this._isCompact = value;
        this.toggleCompactLegend(value);
    }

    _isCompact: boolean = false;

    @Output() readonly exitCompactViewEvent: EventEmitter<boolean> = new EventEmitter();

    constructor(_vcr: ViewContainerRef) {
        super(_vcr, true);
        this.registerEvent('exitCompactView', this.exitCompactViewEvent);
    }

    async ngAfterViewInit() {
        this.mapViewRef = await this.setupMapViewRef(this.mapViewRef);
        this.isReady();
    }

    showHideInfo() {
        this.collapseDescription = !this.collapseDescription;
    }

    toggleEdit() {
        this.editTitle = !this.editTitle;

        if (this.editTitle) {
            this.mapName = this.mapViewRef.mapcoreViewProps.name;
        }
    }

    saveMapName() {
        this.editTitle = false;
        this.mapViewRef.mapcoreViewProps.name = this.mapName;
    }

    private toggleCompactLegend(isCompact) {
        if (isCompact) {
            this.showDescription = false;
            this.showOptionMenu = false;
        } else {
            this.showDescription = true;
            this.showOptionMenu = true;
        }
    }

    exitCompactView() {
        this.exitCompactViewEvent.emit(true);
    }
}
